import { ReactNode } from 'react';
import { IntlShape } from 'react-intl';

import Civilities from 'constants/civilities';

import { SelfService } from 'modules/selfServices/types/SelfService';
import { CustomerInfo } from 'modules/selfServices/types/CustomerInfo';
import { Extension, MediaMimeType, MediaSupport } from 'types/mediaTypes';


export const required = <T>(value: T) => (typeof value !== 'boolean' && !value ? 'validation.required' : undefined);

// @ts-ignore
const PLATE_NUMBER_VALIDATION_REGEX = /^[\p{L}\p{N} !@#$&()\-`.+,/"_=*?'{}:]{1,80}$/u;
export const validatePlateNumber = (value: string, isBreakdown: boolean, intl: IntlShape) => {
  if (!value) {
    return intl.formatMessage({ id: 'validation.required', defaultMessage: 'Please answer to continue.' });
  }

  if (isBreakdown && !PLATE_NUMBER_VALIDATION_REGEX.test(value)) {
    return intl.formatMessage({
      id: 'validation.plateNumber',
      defaultMessage: 'The license plate should only contain alphanumeric characters and symbols',
    });
  }

  return undefined;
};

// eslint-disable-next-line no-useless-escape
const EMAIL_VALIDATION_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;
export const validateEmail = (email: string) => {
  const pattern = RegExp(EMAIL_VALIDATION_REGEX);
  return !email || pattern.test(email) ? undefined : 'validation.email';
};

export const validateRequiredEmail = (email: string) => {
  const pattern = RegExp(EMAIL_VALIDATION_REGEX);
  return !email || !pattern.test(email) ? 'validation.email' : undefined;
};

export const formatToArray = <T>(value: Array<T> = []) => value ?? [];

export const formatUndefined = <T>(value: T) => value;

export const round = (value:number, decimals = 2) => {
  const powerDecimal = 10 ** decimals;
  return Math.round(value * powerDecimal) / powerDecimal;
};

export const isAuthorizedFile = (file:File, acceptor?: MediaSupport): boolean => {
  if (acceptor) {
    const extension:Extension = `.${file.name.split('.').pop()}`;
    return (acceptor.types?.includes(file.type as MediaMimeType) ?? true)
    && (acceptor.extensions?.includes(extension.toLowerCase() as Extension) ?? true);
  }
  return true;
};

export const formatSelectData = (data: Array<string>, intl: IntlShape, key: string) => (
  data.reduce((acc, item) => ({
    ...acc,
    [item]: intl.formatMessage({ id: `${key}.${item}`, defaultMessage: item }),
  }), {} as Record<string, ReactNode>)
);

export const getExtras = (selfService: SelfService) => selfService?.checklists?.flatMap(
  ({ items = [] }) => items.flatMap(({ advices = [] }) => advices),
);

export const getDisplayName = (customerInfo: CustomerInfo = {}) => {
  let { displayName } = customerInfo;

  if (!displayName) {
    if (customerInfo.civility === Civilities.COMPANY) {
      displayName = customerInfo.companyName;
    } else {
      displayName = [customerInfo.firstName, customerInfo.lastName].join(' ');
    }
  }

  return displayName ?? '';
};